import { useCallback, useEffect, useState } from 'react';
import { useUsedCurrencies } from 'common/hooks';
import { worldCurrencies } from 'utilities';

export const useCurrencies = () => {
  const usedCurrencies = useUsedCurrencies();
  const [currencies, setCurrencies] = useState<{ code: string; symbol: string }[]>([]);

  const setInitialCurrencies = useCallback(() => {
    const tmpCurrencies = [...new Set(usedCurrencies)];
    setCurrencies(tmpCurrencies.map(code => ({ code, symbol: worldCurrencies[code] })));
  }, [usedCurrencies]);

  useEffect(() => {
    if (usedCurrencies) {
      setInitialCurrencies();
    }
  }, [setInitialCurrencies, usedCurrencies]);

  const showMore = () => {
    const tmpCurrencies = [...new Set([...usedCurrencies, ...Object.keys(worldCurrencies)])];
    setCurrencies(tmpCurrencies.map(code => ({ code, symbol: worldCurrencies[code as keyof typeof worldCurrencies] })));
  };

  const showLess = () => {
    setInitialCurrencies();
  };

  return {
    usedCurrencies, currencies, setCurrencies, showMore, showLess
  }
}